import React from 'react'
import PropTypes from 'prop-types'
import Toolbar from '../../common/Toolbar'
import Block from '../Block/Block'
import { StyledButton as Button } from '../../common/Button'
import { StyledFormElement as FormElement } from '../../common/FormElement'
import styled from 'react-emotion'
import { border, z, space, color } from '../../../style'

export const QueueBlocks = styled('div')({
  padding: `${space.small}px 0`,
  display: 'flex',
  overflow: 'auto',
  width: '100%'
})
export const QueueBlock = styled('div')(({ aspect, current }) => ({
  height: 60,
  width: 60 / aspect,
  marginLeft: space.small,
  position: 'relative',
  flexShrink: 0,
  '&:last-child:before': {
    content: '""',
    position: 'absolute',
    right: -space.small,
    width: space.small,
    height: space.small
  },
  ':after': current && {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    border: `4px solid ${color.red}`
  }
}))

export const Queue = styled(
  ({
    blocks,
    toggleQueue,
    selectQueueIndex,
    selectedIndex,
    clearQueue,
    className,
    t
  }) => {
    return (
      <div className={className}>
        <Toolbar top>
          <FormElement>{t('queue.adding')}</FormElement>
          <Toolbar.Spacer />
          <Button onClick={clearQueue}>{t('queue.clear')}</Button>
          <Button primary onClick={toggleQueue}>
            {t('queue.done')}
          </Button>
        </Toolbar>

        <QueueBlocks>
          {blocks.length
            ? blocks.map((block, i) => (
                <QueueBlock
                  key={block.id}
                  current={i === selectedIndex}
                  aspect={block.aspect}
                  onClick={() => selectQueueIndex(i)}
                >
                  <Block
                    location="queue"
                    block={block}
                    layout={{
                      width: 60 / block.aspect,
                      height: 60
                    }}
                  />
                </QueueBlock>
              ))
            : t('queue.empty')}
        </QueueBlocks>
      </div>
    )
  }
)({
  label: 'Queue',
  borderTop: border,
  display: 'flex',
  flexDirection: 'column',
  background: '#fff',
  position: 'absolute',
  bottom: 0,
  width: '100%',
  zIndex: z.queue
})

Queue.propTypes = {
  blocks: PropTypes.array,
  toggleQueue: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  selectQueueIndex: PropTypes.func.isRequired
}

export default Queue
